import { Fragment } from 'react'
import { Gift } from 'lucide-react'
import { REWARDS_COPY } from '@/locales/en'
import { RewardT } from '@/common/types'
import RewardItem from './RewardItem'

type Props = {
    rewards: RewardT[]
    totalRewards: number
}

export function RewardsList({ rewards, totalRewards }: Props) {
    return (
        <div className="self-stretch p-4 rounded-2xl outline outline-1 outline-offset-[-1px] outline-border-outline flex flex-col justify-center items-start gap-4 md:gap-6 overflow-hidden">
            <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="self-stretch inline-flex justify-start items-start gap-4">
                    <Gift size={20} />
                    <div className="w-52 self-stretch justify-center text-content-primary text-n font-medium font-['Inter'] leading-5">
                        {REWARDS_COPY.freeTradesTitle}
                        {` (${totalRewards})`}
                    </div>
                </div>
                <div className="justify-center text-content-secondary text-xs font-normal font-['Inter'] leading-5">
                    {REWARDS_COPY.freeTradesDescription}
                </div>
            </div>

            {rewards.map((r, idx) => (
                <Fragment key={r.promotionId}>
                    <RewardItem reward={r} />

                    {idx < rewards.length - 1 && (
                        <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-border-divider" />
                    )}
                </Fragment>
            ))}
        </div>
    )
}
